import { createApp } from 'vue'
import ArticleAnchors from './ArticleAnchors'

const el = '.kb-component--article-anchors'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((ArticleAnchor) => {
            if (ArticleAnchor.hasAttribute('data-v-app')) return false
            const component = createApp(ArticleAnchors).use(Store)
            component.mount(ArticleAnchor)
        })
    }
}
